import brochureForm from '../modules/brochure/brochure-form';
import formTracker from '../modules/utility/form-event-tracker';

if (brochureForm.canInit('#brochure-form')) {
    brochureForm.init();
}

if (formTracker.canInit('#brochure-form')) {
    formTracker.init();
}

document.addEventListener('DOMContentLoaded', function () {
    const select = document.getElementById('deliveryMethod');
    if (!select) return;

    const postalFields = document.querySelectorAll('.postal-field');
    const submitBtn = document.getElementById('brochure-submit-btn');

    function updateVisibility() {
        const isDownload = select.value === 'download';

        postalFields.forEach(function (field) {
            field.style.display = isDownload ? 'none' : '';

            // stop hidden required fields from blocking submit
            const input = field.querySelector('input');
            if (input && !field.classList.contains('postal-field-optional')) {
                input.required = !isDownload;
            }
        });

        if (submitBtn) {
            if (isDownload) {
                submitBtn.classList.remove('mt-auto');
                submitBtn.classList.add('mt-md-5');
            } else {
                submitBtn.classList.remove('mt-md-5');
                submitBtn.classList.add('mt-auto');
            }
        }
    }

    select.addEventListener('change', updateVisibility);
    updateVisibility();   // set initial state on load

    const autoDownload = document.getElementById('auto-download-brochure');
    if (autoDownload) {
        const url = autoDownload.dataset.url;
        if (url) {
            // trigger the download
            const link = document.createElement('a');
            link.href = url;
            link.download = '';   // hint to download rather than navigate
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            // optionally push the tracking event (your FileDownloadEvent)
            const dataLayerEvent = new FileDownloadEvent('Digital Brochure', 'pdf', 'brochure', url);
            dataLayerEvent.push();
        }
    }
});
